"use client";

import { useAppSelector } from "@/store/hooks";
import { Loader2 } from "lucide-react";

export const GlobalLoading = () => {
  const { isLoading, message } = useAppSelector(
    (state) => state.ui.globalLoading
  );

  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-black/50 dark:bg-black/70 backdrop-blur-sm flex items-center justify-center">
      <div className="bg-card text-card-foreground border border-border rounded-lg p-8 shadow-xl max-w-sm mx-4 flex flex-col items-center space-y-4">
        <Loader2 className="w-8 h-8 animate-spin text-primary" aria-hidden />
        <div className="text-center">
          <h3 className="font-semibold text-foreground">
            {message || "Loading..."}
          </h3>
          <p className="text-sm text-muted-foreground mt-1">
            Please wait while we process your request
          </p>
        </div>
      </div>
    </div>
  );
};